/**
 * Menu mobile, modal vidéo, header sticky, message de succès HubSpot, menu du glossaire.
 * Fichier historique en jQuery (ex assets/js/mobile-menu.js), concaténé tel quel dans custom.min.js.
 */
(function ($) {
    // Garde de transition : si l'ancien assets/js/mobile-menu.js est encore enqueué (il pose
    // window.slideMenuMobile), ne pas doubler les handlers. À retirer une fois la prod déployée.
    if (Array.isArray(window.slideMenuMobile)) return;

    jQuery.fn.outerHTML = function () {
        return jQuery("<div />").append(this.eq(0).clone()).html();
    };

    window.slideMenuMobile = [];

    $(document).ready(function () {
        var bottommobile = $(".bottommobile");
        var newBottommobile = bottommobile.clone(true);
        bottommobile.remove();
        $("#mobile-menu-main").append(
            "<li class='bottommobile'>" + newBottommobile.html() + "</li>"
        );

        $("#mobile-menu-main").css({
            width: $(window).width() + "px",
        });

        $(window).resize(function () {
            $("#mobile-menu-main").css({
                width: $(window).width() + "px",
            });
        });

        $(document.body).on("keydown", "#burgermobile", function (e) {
            if (e.key === " ") {
                e.preventDefault();
                $(this).trigger("click");
            }
        });

        $(document.body).on("click", "#burgermobile", function (e) {
            e.preventDefault();
            $("#burgermobile").blur();
            $("#burgermobile").attr("aria-expanded", $("header.header").hasClass("openmobilenav") ? "false" : "true");
            if ($("header.header").hasClass("openmobilenav")) {
                $("header.header").removeClass("anim");
                $("#burgermobile").removeClass("active");
                setTimeout(function () {
                    $("header.header").removeClass("openmobilenav");
                    slideMenuMobile = [];
                    $(".mobile-navigation .view").remove();
                    $(".wrappermenu").css({
                        transform:
                            "translateX(-" +
                            $(window).width() * slideMenuMobile.length +
                            "px)",
                    });
                }, 350);
            } else {
                $("header.header").addClass("openmobilenav");

                setTimeout(function () {
                    $("#burgermobile").addClass("active");
                    $("header.header").addClass("anim");
                });
            }
        });

        $("body").on("click", "a.backmenumobile", function (e) {
            e.preventDefault();
            var view = $(this).closest(".view");
            slideMenuMobile.pop();
            $(".wrappermenu").css({
                transform:
                    "translateX(-" +
                    $(window).width() * slideMenuMobile.length +
                    "px)",
            });
            if (slideMenuMobile.length == 0) {
                $("header.header").removeClass("viewactive");
            }
            setTimeout(function () {
                view.remove();
            }, 350);
        });

        $("body").on(
            "click",
            ".mobile-navigation .view li.menu-item-has-children > a",
            function (e) {
                e.preventDefault();
                var text = $(this).text();
                var parentMenu =
                    '<a href="#" class="backmenumobile">' + text + "</a>";
                var view =
                    "<div data-viewnumber='" +
                    (slideMenuMobile.length + 1) +
                    "' class='view' style='width:" +
                    $(window).width() +
                    "px'>" +
                    parentMenu +
                    $(this)
                        .closest("li")
                        .find("ul.sub-menu")
                        .first()
                        .outerHTML() +
                    "</div>";
                slideMenuMobile.push(view);
                $(".wrappermenu").append(view);
                $(".wrappermenu").css({
                    transform:
                        "translateX(-" +
                        $(window).width() * slideMenuMobile.length +
                        "px)",
                });
            }
        );

        $("body").on(
            "click",
            "#mobile-menu-main li.menu-item-has-children > a",
            function (e) {
                e.preventDefault();

                var text = $(this).text();
                var parentMenu =
                    '<a href="#" class="backmenumobile">' + text + "</a>";
                var view =
                    "<div data-viewnumber='" +
                    (slideMenuMobile.length + 1) +
                    "' class='view' style='width:" +
                    $(window).width() +
                    "px'>" +
                    parentMenu +
                    $(this)
                        .closest("li")
                        .find("ul.sub-menu")
                        .first()
                        .outerHTML() +
                    "</div>";
                slideMenuMobile.push(view);

                $(".wrappermenu").append(view);
                $("header.header").addClass("viewactive");
                $(".wrappermenu").css({
                    transform:
                        "translateX(-" +
                        $(window).width() * slideMenuMobile.length +
                        "px)",
                });
            }
        );
    });

    // Élément qui a ouvert la modal vidéo : le focus y revient à la fermeture.
    var modalTrigger = null;

    function restoreModalFocus() {
        if (modalTrigger && typeof modalTrigger.focus === "function") {
            modalTrigger.focus();
        }
        modalTrigger = null;
    }

    // ajout d'un listener sur la touche escape pour fermer la modal si elle est ouverte
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            if ($(".modal").hasClass("show")) {
                $(".modal").removeClass("show");
                setTimeout(function () {
                    $(".modal").removeClass("display");
                    $(".modal .content").html("");
                }, 500);
                restoreModalFocus();
            }
        }
    });

    $("body").on("click", ".showvideo:not(.nopopup)", function (e) {
        e.preventDefault();
        var videoframe = $(this).attr("data-iframe");
        modalTrigger = this;
        $(".modal.video .content").html(videoframe);
        $(".modal.video").addClass("display");

        setTimeout(function () {
            $(".modal.video").addClass("show");
            // Le clavier suit : focus sur le bouton de fermeture.
            $(".modal.video .closemodal").trigger("focus");
        }, 100);
    });

    $("body").on("click", ".showvideo.nopopup", function (e) {
        e.preventDefault();
        var videoframe = $(this).attr("data-iframe");
        var firstParent = $(this).closest("div");
        var isFigure = firstParent.find("figure").length;

        // check if diapo--wrapper is parent
        var isDiapoWrapper = $(this).closest(".diapo--wrapper");
        if (isDiapoWrapper.length > 0) {
            isDiapoWrapper.find("p.description").remove();
            isDiapoWrapper.find("div.overlay").remove();
        }

        if (isFigure) {
            firstParent.find("figure").append(videoframe);
        } else {
            firstParent.append(videoframe);
        }

        $(this).hide();
    });

    $("body").on("click", ".closemodal, .modal .overlay", function (e) {
        e.preventDefault();

        var modal = $(this).closest(".modal");
        modal.removeClass("show");

        setTimeout(function () {
            // if modal has video class
            if (modal.hasClass("video")) {
                modal.find(".content").html("");
            }
            modal.removeClass("display");
        }, 500);
        restoreModalFocus();
    });

    // add sticky to header on scroll
    $(window).scroll(function () {
        if ($(window).scrollTop() > 1) {
            $("header.header").addClass("sticky");
        } else {
            $("header.header").removeClass("sticky");
        }
    });

    // event listener to hubsport form submit "hsvalidatedsubmit"
    document.addEventListener("hsvalidatedsubmit", function (event) {
        // Identifiez le formulaire qui a été soumis
        const submittedForm = event.target.closest("form");

        if (submittedForm) {
            // Ajoutez dynamiquement un message de succès
            let successMessage =
                submittedForm.querySelector(".success-message");
            if (!successMessage) {
                successMessage = document.createElement("div");
                successMessage.className = "success-message";
                successMessage.textContent =
                    "Merci ! Votre formulaire a été soumis avec succès.";
                successMessage.style.color = "green";
                successMessage.style.marginTop = "20px";
                submittedForm.appendChild(successMessage);
            }

            // Affichez le message
            successMessage.style.display = "block";
        }
    });
})(jQuery);

document.addEventListener("DOMContentLoaded", () => {
        const glossaireBlocks = document.querySelectorAll(".block-glossaire");

        glossaireBlocks.forEach((block) => {
            const menu = block.querySelector(".glossaire-menu");
            const sections = block.querySelectorAll(".glossaire-section");

            // Observer pour les sections
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const id = entry.target.getAttribute("id");
                        if (entry.isIntersecting && id) {
                            setActiveMenuItem(menu, id);
                        }
                    });
                },
                {
                    threshold: 0.4, // Détecte quand 50% de la section est visible
                    rootMargin: "-130px 0px -50px 0px", // Ajuste pour compenser les marges
                }
            );

            sections.forEach((section) => {
                observer.observe(section);
            });
        });

        /**
         * Met à jour les liens actifs dans le menu
         * @param {HTMLElement} menu - Le menu contenant les liens
         * @param {string} activeId - L'ID de la section active
         */
        function setActiveMenuItem(menu, activeId) {
            const links = menu.querySelectorAll("a");
            links.forEach((link) => {
                const href = link.getAttribute("href");
                if (href === `#${activeId}`) {
                    link.classList.add("active");
                    // scroll horizontal du parent du menu
                    const parent = link.closest(".glossaire-menu");
                    if (parent) {
                        const linkRect = link.getBoundingClientRect();
                        const parentRect = parent.getBoundingClientRect();
                        const offset = linkRect.left - parentRect.left;
                        parent.scrollLeft +=
                            offset - parentRect.width / 2 + linkRect.width / 2;
                    }
                } else {
                    link.classList.remove("active");
                }
            });
        }
});
